var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChecklistTwoColors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 118,
    viewBox: "0 0 150 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2578 53.474C19.2578 53.474 24.0473 30.9424 36.0999 30.9424C48.1525 30.9424 54.5631 66.3634 25.2473 70.2161L19.2578 53.474Z",
    fill: "#F4A28C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.2578 53.474C19.2578 53.474 24.0473 30.9424 36.0999 30.9424C48.1525 30.9424 54.5631 66.3634 25.2473 70.2161L19.2578 53.474Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.363 6.62109H29.3789V99.6106H104.363V6.62109Z",
    fill: "#24285B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8367 12.2632H36.6367V91.8158H96.8367V12.2632Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6684 1.03174H50.8789V14.9528H83.6684V1.03174Z",
    fill: "#FFD200"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M78.4738 47.9478H63.6001V51.2267H78.4738V47.9478Z",
    fill: "#A8A8A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M87.1633 54.4634H63.6001V57.7423H87.1633V54.4634Z",
    fill: "#A8A8A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M78.4738 69.0317H63.6001V72.3107H78.4738V69.0317Z",
    fill: "#A8A8A8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M87.1633 75.5527H63.6001V78.8317H87.1633V75.5527Z",
    fill: "#A8A8A8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7315 25.0317H44.2947V38.4686H57.7315V25.0317Z",
    fill: "#6868FE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7315 45.9951H44.2947V59.432H57.7315V45.9951Z",
    fill: "#6868FE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7315 66.958H44.2947V80.3948H57.7315V66.958Z",
    fill: "#6868FE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3275 28.9564C54.7876 29.3117 54.8725 29.9728 54.5172 30.4329L51.233 34.6855C51.0273 34.9519 50.7066 35.1039 50.3701 35.0943C50.0337 35.0848 49.722 34.915 49.5317 34.6374L47.9475 32.3269C47.6188 31.8474 47.7409 31.1922 48.2204 30.8634C48.6999 30.5347 49.3551 30.6569 49.6838 31.1364L50.4505 32.2545L52.851 29.1461C53.2063 28.686 53.8674 28.601 54.3275 28.9564Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.327 49.8823C54.7873 50.2373 54.8727 50.8983 54.5176 51.3587L51.2334 55.6166C51.0277 55.8832 50.707 56.0353 50.3704 56.0259C50.0339 56.0165 49.7221 55.8466 49.5317 55.5689L47.9475 53.2584C47.6188 52.7789 47.7409 52.1237 48.2204 51.795C48.6999 51.4662 49.3551 51.5884 49.6838 52.0679L50.4499 53.1852L52.8506 50.0729C53.2057 49.6125 53.8667 49.5272 54.327 49.8823Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M68.3579 67.9266L66.3789 71.3687L73.0421 70.5213L80.1052 67.9529C80.1052 67.9529 83.721 73.7424 89.7737 77.1739C96.4508 80.8394 101.578 86.7947 104.21 93.9424L104.379 94.4108V62.3055L95.1052 52.5845L68.3579 67.9266Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3275 70.9725C54.7876 71.3278 54.8725 71.9889 54.5172 72.449L51.233 76.7016C51.0273 76.968 50.7066 77.12 50.3701 77.1105C50.0337 77.1009 49.722 76.9311 49.5317 76.6535L47.9475 74.343C47.6188 73.8635 47.7409 73.2083 48.2204 72.8796C48.6999 72.5508 49.3551 72.673 49.6838 73.1525L50.4505 74.2706L52.851 71.1622C53.2063 70.7021 53.8674 70.6172 54.3275 70.9725Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.358 50.8424C103.358 50.8424 95.7895 44.0582 84.5842 48.7371C75.8105 52.4213 79.9632 56.7529 84.679 56.5687C89.3948 56.3845 97.3105 53.1687 96.7579 61.0003C96.2579 67.9003 87.7 57.9792 82.7948 58.3687C77.8895 58.7582 78.4526 64.3319 84.4947 67.3898C90.5369 70.4477 99.0211 77.0687 105.626 71.8687C112.232 66.6687 110.342 57.4319 103.358 50.8424Z",
    fill: "#F4A28C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M115.386 47.1313L113.056 42.2832L70.7141 62.6339L73.0442 67.4819L115.386 47.1313Z",
    fill: "#6868FE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M101.379 73.8056L127.879 116.948L149.5 98.4898L111.474 61.1108L101.379 73.8056Z",
    fill: "#6868FE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7105 62.6372L65.0579 68.4688L73.0421 67.4846L70.7105 62.6372Z",
    fill: "#24285B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7 45.0791C28.7 45.0791 38.0053 35.5686 42.021 36.4107C45.3368 37.1107 45.3421 43.7054 38.1158 49.2002C36.6488 50.3032 35.436 51.7087 34.5597 53.3215C33.6834 54.9342 33.1641 56.7165 33.0368 58.5475C32.8316 61.616 31.8158 65.2686 28.7 68.0212C22.1474 73.8107 17.2842 68.7686 17.9158 60.937C18.5474 53.1054 18.9737 50.7897 28.7 45.0791Z",
    fill: "#F4A28C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3212 66.7792L28.8212 115.174L0.136963 109.674L14.5633 61.395L32.3212 66.7792Z",
    fill: "#6868FE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M78.4738 26.5107H63.6001V29.7897H78.4738V26.5107Z",
    fill: "#A8A8A8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M87.1633 33.0264H63.6001V36.3053H87.1633V33.0264Z",
    fill: "#A8A8A8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M17.6262 113.027L23.842 64.2109L32.321 66.7794L28.821 115.174L17.6262 113.027Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M101.379 73.8052L106.053 67.9263L137.442 108.784L127.879 116.947L101.379 73.8052Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistTwoColors);
export default __webpack_public_path__ + "static/media/checklist-two-colors.51a057fb7641c8fdbc0eeb4d30da2d59.svg";
export { ForwardRef as ReactComponent };